import { createContext, useContext } from 'react'
import { hasPermission } from '#modules/permissions'

export type PermissionContextType = {
  permissions: Set<string>
  loading: boolean
}

export const PermissionContext = createContext<PermissionContextType>({
  permissions: new Set(),
  loading: true,
})

export function usePermission(required: string): boolean {
  const { permissions, loading } = useContext(PermissionContext)
  if (loading) return false
  return hasPermission(permissions, required)
}

export function usePermissions(...required: string[]): boolean {
  const { permissions, loading } = useContext(PermissionContext)
  if (loading) return false
  return required.every(p => hasPermission(permissions, p))
}

export function useAnyPermission(...required: string[]): boolean {
  const { permissions, loading } = useContext(PermissionContext)
  if (loading) return false
  return required.some(p => hasPermission(permissions, p))
}

export function usePermissionLoading(): boolean {
  const { loading } = useContext(PermissionContext)
  return loading
}

export { hasPermission }
